import { Component, Input } from '@angular/core';

@Component({
  selector: 'ds-icon-badge',
  templateUrl: './icon-badge.component.html',
  styleUrls: ['./icon-badge.component.scss'],
})
export class IconBadgeComponent {
  @Input() iconClass = 'security';
  @Input() tooltip = '';
}
